import { Grid } from "@chakra-ui/react";
import GameItem from "./GameItem";

function AvailableGames({ games, minW = "200px", onItemHover, isPC }) {
  return (
    <Grid
      alignItems="center"
      justifyItems="center"
      templateColumns={`repeat( auto-fit, minmax(${minW}, 1fr) )`}
      margin="16px auto"
      maxW="1200px"
      gap="8px"
      padding="16px"
      borderRadius="10px"
    >
      {games.map((game) => {
        const { title, thumbnail, id, ratings, hover_video} = game;
        return (
          <GameItem
            title={title}
            thumbnail={`https://api.leaderbored.gg${thumbnail.url}`}
            // thumbnail={`https://leaderbored-api.taktylstudios.com${thumbnail.url}`} 
            id={id}
            key={id}
            rating={ratings}
            // for game pop up card
            onHover={onItemHover}
            gameData={game}
            isPC={isPC}
            vidPath={`https://api.leaderbored.gg${hover_video.url}`}
            // vidPath={`https://leaderbored-api.taktylstudios.com${hover_video?.url}`}
          />
        );
      })}
    </Grid>
  );
}

export default AvailableGames;
